module.exports = __webpack_public_path__ + "static/media/Presentation.117e7272.mov";